import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { SessionStorageService } from 'src/app/core/services/storage/session-storage.service'

import { SessionStorageKeys } from '../../constants/session-storage-keys'

/**
 *
 * @deprecated Since this component is exposing html injection vulnerability. Instead use ConformationDialogComponent
 * @export
 * @class ComformationDialogComponent
 */
@Component({
  selector: 'app-comformation-dialog',
  templateUrl: './comformation-dialog.component.html',
  styleUrls: ['./comformation-dialog.component.scss']
})
export class ComformationDialogComponent {
  title: string
  body: string
  warning?: string
  okButtonName: string
  cancelButtonName: string
  closeButtonName: string
  selectedLanguage
  constructor(
    public dialogRef: MatDialogRef<ComformationDialogComponent>,
    private readonly sessionStorage: SessionStorageService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    dialogRef.disableClose = true
    this.title = data.title
    this.body = data.body
    this.warning = data.warning ? data.warning : null
    this.okButtonName = data.okButtonName
    this.cancelButtonName = data.cancelButtonName
    // this.closeButtonName = data.closeButtonName ? data.closeButtonName : null
    this.selectedLanguage = this.sessionStorage.get(SessionStorageKeys.selectedLanguage)
  }

  respone(value: boolean) {
    this.dialogRef.close({ respone: value, response: value })
  }
}
